import type { QueryClient } from '@tanstack/react-query';

let queryClient: QueryClient | undefined;

/** Called from the root QueryClientProvider wrapper so non-React code can read the cache. */
export const setRegisteredQueryClient = (client: QueryClient | undefined) => {
  queryClient = client;
};

export const getRegisteredQueryClient = () => queryClient;
